'use client';

import createDOMPurify from 'dompurify';
import { useMemo, ElementType, HTMLAttributes } from 'react';

type SafeHTMLProps<T extends ElementType> = {
  html: string;
  as?: T;
} & HTMLAttributes<HTMLElement>;

export default function SafeHTML<T extends ElementType = 'div'>({
  html,
  as,
  ...rest
}: SafeHTMLProps<T>) {
  // 1. Инициализируем только в браузере
  const DOMPurify = useMemo(
    () => (typeof window !== 'undefined' ? createDOMPurify(window) : null),
    []
  );

  const Tag = as || 'div';
  const clean = DOMPurify ? DOMPurify.sanitize(html) : html; // SSR-fallback

  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: clean }} />;
}
